import Component from 'vue-class-component'
import Vue from 'vue'
import { IUser } from '../../model/user'
import userStore from '../../store/user/user-store'
import Tags from '../shared/Tags.vue'
import statementStore from '../../store/statement/statement-store'
import authStore from '../../store/auth/auth-store'

@Component({
  name: 'statementTags',
  props: ['statement'],
  components: { 'tags' : Tags }
})
export default class StatementTags extends Vue {

  get isEditable () {
    return authStore.user && this.$props['statement'].meta.creator.id === authStore.user.id
  }

  protected addStatementTag (): void {
    statementStore.dispatchAddStatementTag(this.$props['statement'])
  }

  protected removeStatementTag (tag: string): void {
    statementStore.dispatchRemoveStatementTag({ statement: this.$props['statement'], tag: tag })
  }

}
